﻿$.fn.dxCtrlBcArticleUpdate = function custom_dxCtrlBcArticleUpdate(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlbcarticleupdate dx-ctrl");
        this.createInstance(new cdxCtrlBcArticleUpdate(this, option));
    }
    return this;
}

window.cdxCtrlBcArticleUpdate = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    var $DivEntete = null;
    var jauge = null
    var $TdEntete = null

    var dxContentEmailBase = null
    function mConstruit() {
        container.empty();
        container.css("position", "relative")

        //mRempmliBt()

        jauge = $("<div/>").appendTo(container).dxCtrlJauge({}).dxCtrlJauge("instance")
        jauge.mShow();

        $DivEntete = $("<div style='width:calc(100% - " + (HeightButton + 15) + "px);padding:0 10px;box-sizing:border-box;'/>").appendTo(container)

        var dxBcAppli = $("<div/>").appendTo($DivEntete).dxCtrlBcChkLienAppli({
            bddCtrl: option.bddCtrl,
            data: option.data
        }).dxCtrlBcChkLienAppli("instance")

        var $Table = $("<table style='width:100%'/>").appendTo($DivEntete)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:1px;padding-right:10px;vertical-align:top;'/>").appendTo($Tr)

        var dxCtrlImage = $("<div style='width:100%;height:100%;'/>").appendTo($Td).dxCtrlImageData({
            bddCtrl: option.bddCtrl,
            size: 120,
            data: option.data,
            showTextOnImage: false,
            showText: false,
            fontSizeText: "30px",
            allowDisplayIcone: true
            //noDataText: "(aucune image)"
        }).dxCtrlImageData("instance");

        $TdEntete = $("<td style='width:100%;vertical-align:top;'/>").appendTo($Tr)

        $("<div/>").appendTo($TdEntete).dxCtrlBcLstDossier({
            labelMode: "floating",
            label: "Dossier de l'article",
            bddCtrl: option.bddCtrl,
            value: option.data.id_bc_dossier_parent,
            onValueChanged: function (idDossierBc) {
                option.data.id_bc_dossier_parent = idDossierBc
                option.bddCtrl.getObjet(option.data).mSaveChamp("id_bc_dossier_parent")
            }
        })

        var $DivObjet = $("<div/>").appendTo($TdEntete)

        var $DivFichier = $("<div style=''/>").appendTo($TdEntete)

        var firstload = true
        dxContentEmailBase = $("<div style='width:calc(100% - " + (HeightButton + 15) + "px);height:calc(100% - " + $DivEntete.innerHeight() + "px);'/>").appendTo(container).dxCtrlContentEmailBase({
            bddCtrl: option.bddCtrl,
            readOnly: false,
            containerObjet: $DivObjet,
            containerFile: $DivFichier,
            data: option.data,
            saveAuto: true,
            allowTag: false,
            onContentReady: function (e) {
                if (firstload) {
                    firstload = false
                    window.setTimeout(function () { mRempliBt() }, 0)
                }
            }
        }).dxCtrlContentEmailBase("instance")


        resizeObserver.mAdd($DivEntete, function () { dxContentEmailBase.element().css("height", "calc(100% - " + $DivEntete.innerHeight() + "px)") })

        jauge.mHide();
    }

    this.mSave = function () {
        dxContentEmailBase.mStopSaveAuto()
    }

    var lstItemToolBarSource = null
    function mRempliBt() {
        if (typeof option.optionPopup == 'undefined') option.optionPopup = {}
        if (typeof option.optionPopup.toolbar == 'undefined' || option.optionPopup.toolbar == null) {
            option.optionPopup.toolbar = dxContentEmailBase.mGetDxToolbar()
            //option.optionPopup.toolbar = $("<div/>").appendTo($TdEntete).dxToolbar({
            //    width: "100%",
            //    items: [],
            //    onContentReady: function (e) {
            //        e.component.element().find(".dx-toolbar-after").addClass("dx-surface")
            //    }
            //}).dxToolbar("instance")
        } else {
            var lstIt = option.optionPopup.toolbar.option("items")
            var lstDel = []
            lstIt.forEach(function (it) { if (it.cssClass != "initial") lstDel.push(it) })
            lstDel.forEach(function (it) { lstIt.splice(lstIt.indexOf(it), 1) })
            option.optionPopup.toolbar.option("items", lstIt)
        }


        var itemsToolbar = []
        itemsToolbar.push({
            location: 'after',
            locateInMenu: 'auto',
            template(itemData, itemIndex, itemElement) {
                $("<div style=''/>").appendTo(itemElement).dxCtrlButton({
                    icon: "fas fa-print",
                    txtTooltip: "Imprimer",
                    onClick: function (e) {
                        jauge.mShow();
                        jauge.option("message", "Génération de l'impression")

                        if (option.data.id_com_email_envoi == null) {
                            dxContentEmailBase.mSaveAuto(function () { mPrint() }, option.bddCtrl.getObjet(option.data).cle() == null)
                        } else { mPrint() }

                        function mPrint() {
                            option.bddCtrl.mAjaxCall({
                                command: "printemailenvoi",
                                id: option.data.id_bc_article,
                                nom_table: "bc_article"
                            }, function (data) {
                                if (data.urlpdf.startsWith("~")) data.urlpdf = data.urlpdf.substring(1)
                                $("<div/>").appendTo("body").dxCtrlViewer({
                                    bddCtrl: option.bddCtrl,
                                    value: [data.urlpdf],
                                    indexCourant: 0
                                })
                                jauge.mHide();
                            })
                        }
                    }
                });
            },
        })
        //itemsToolbar.push({
        //    location: 'after',
        //    locateInMenu: 'auto',
        //    template(itemData, itemIndex, itemElement) {
        //        var dxBtImportInEmail = $("<div style=''/>").appendTo(itemElement).dxCtrlCmdImportExportFile({
        //            bddCtrl: option.bddCtrl,
        //            titleExport: "Sauvegarder dans la box",
        //            onValideImport: function (lstPathName) {
        //                $("<div/>").appendTo(container).dxCtrlCmdImportInEmail({
        //                    bddCtrl: option.bddCtrl,
        //                    lstPathName: lstPathName,
        //                    container: container,
        //                    onGetData: function () {
        //                        return dxContentEmailBase.mGetData()
        //                    },
        //                    onImport: function (data, changeObjet, viderFichier, ajouterFichier, remplacerToutHtml, funcFin) {
        //                        if (changeObjet) {
        //                            dxContentEmailBase.mChangeObjet(data.objet)
        //                            option.data.objet = data.objet
        //                        }
        //                        if (viderFichier) dxContentEmailBase.mClearFiles()
        //                        if (ajouterFichier) dxContentEmailBase.mAddFiles(data.lstfile)
        //                        jauge.mShow()
        //                        dxContentEmailBase.mChangeHtml(data.html, data.htmlSansBody, remplacerToutHtml, function () {
        //                            funcFin()
        //                            jauge.mHide()
        //                        })
        //                    }
        //                })
        //            },
        //            onExport: function (pathNameFile) {
        //                if (dxContentEmailBase.isDirty()) {
        //                    dxContentEmailBase.mSave(function () { mExport() })
        //                } else { mExport() }
        //                function mExport() {
        //                    dxContentEmailBase.mExportBox(pathNameFile, function () {
        //                        mNotify("Le fichier a été sauvegardé dans votre box", "success", 2000)
        //                    })
        //                }
        //            }
        //        }).dxCtrlCmdImportExportFile("instance")
        //    },
        //})
        itemsToolbar.push({
            location: 'after',
            locateInMenu: 'auto',
            template(itemData, itemIndex, itemElement) {
                $("<div style=''/>").appendTo(itemElement).dxCtrlButton({
                    icon: "fas fa-trash-alt",
                    txtTooltip: "Mettre à la corbeille",
                    onClick: function (e) {
                        var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                            target: e.component.element(),
                            contentTemplate: function (contentElement) {
                                contentElement.css("padding", "25px")
                                $("<div style='padding-bottom:15px;'>Mettre le message<br/>à la corbeille</div>").appendTo(contentElement)
                                $("<div/>").appendTo(contentElement).dxCtrlButton({
                                    text: "Confirmez",
                                    onClick: function (e) {
                                        tt.hide()
                                        option.bddCtrl.getObjet(option.data).mDelData(function () {
                                            page.mRemovePopup(option.data)
                                        })
                                    }
                                })
                            }
                        }).dxCtrlTooltip("instance");
                        tt.show();
                    }
                });
            },
        })

        itemsToolbar.reverse()
        if (!lstItemToolBarSource) lstItemToolBarSource = option.optionPopup.toolbar.option("items").slice()
        var lstItems = lstItemToolBarSource.slice()
        itemsToolbar.forEach(function (itemT) { lstItems.unshift(itemT) })
        option.optionPopup.toolbar.option("items", lstItems)
    }

    this.isDirty = function (value) {
        return dxContentEmailBase.isDirty(value)
    }

    this.element = function () { return container; }
    this.component = function () { return dx; }

    mConstruit();
}